<template>
    <section style="display: flex;" v-if="newBizParam">

        <h5 style="margin-top: 10px;">采集企业客户限制：</h5>
        <el-tabs v-model="ruleModel2">
            <el-tab-pane label="按天/按月" name="first" >
                <!-- 规则5 start -->
                <div class="rule">
                  
                    <el-checkbox @change="changeCheck(3);$emit('changeData',newBizParam)"  v-model="newBizParam.dayCustomerSumAndSame.enabled"></el-checkbox>
                    <span class="txt">规则1：限制</span>
                    <div :class="!newBizParam.dayCustomerSumAndSame.isSamePerson&&newBizParam.dayCustomerSumAndSame.enabled&&isOpenCheck?'red-border':''">
                        <el-select @change="$emit('changeData',newBizParam)" :disabled="!newBizParam.dayCustomerSumAndSame.enabled" class="w130" v-model="newBizParam.dayCustomerSumAndSame.isSamePerson" placeholder="请选择" clearable>
                            <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <span class="txt"><i class="theme-color">同一天</i>收集<i class="theme-color">企业客户</i>的频次</span>
                    <p class="tips" v-if="!newBizParam.dayCustomerSumAndSame.isSamePerson&&newBizParam.dayCustomerSumAndSame.enabled&&isOpenCheck">请将规则填写完整</p>
                </div>
                <div class="rule-child" v-if="newBizParam.dayCustomerSumAndSame.enabled">
                    <div class="rule" v-for="(item,index) in newBizParam.dayCustomerSumAndSame.ruleItemList" :key="index">
                        <el-checkbox @change="item.sameLimitMax=null;item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)" v-model="item.enabled"></el-checkbox>
                        <span class="txt"><i class="theme-color">{{ item.customerType==1?'药店':item.customerType==2?'商业公司':item.customerType==4?'医院':'其他' }}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="item.sumLimitMax"  @input="$forceUpdate();$emit('changeData',newBizParam)" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                            :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次，同一家不可超过<span :class="!item.sameLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="item.sameLimitMax" @input="$forceUpdate();$emit('changeData',newBizParam)"  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                            :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                        <p class="tips" v-if="(!item.sameLimitMax||!item.sumLimitMax)&&item.enabled&&isOpenCheck">请将规则填写完整</p>
                    </div>
                
                </div>
                <!-- 规则5 end-->

                <!-- 规则6 start-->
                <div class="rule">
                  
                    <el-checkbox @change="changeCheck(6);$emit('changeData',newBizParam)" v-model="newBizParam.dayCustomerSameSum.enabled"></el-checkbox>
                    <span class="txt">规则2：限制</span>
                    <div :class="!newBizParam.dayCustomerSameSum.isSamePerson&&newBizParam.dayCustomerSameSum.enabled&&isOpenCheck?'red-border':''">
                        <el-select @change="$emit('changeData',newBizParam)" :disabled="!newBizParam.dayCustomerSameSum.enabled" class="w130" v-model="newBizParam.dayCustomerSameSum.isSamePerson" placeholder="请选择" clearable>
                            <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <span class="txt"><i class="theme-color">同一天</i>收集<i class="theme-color">同一家企业客户</i>的频次</span>
                    <p class="tips" v-if="!newBizParam.dayCustomerSameSum.isSamePerson&&newBizParam.dayCustomerSameSum.enabled&&isOpenCheck">请将规则填写完整</p>
                </div>
                <div class="rule-child" v-if="newBizParam.dayCustomerSameSum.enabled">
                    <div class="rule" v-for="(item,index) in newBizParam.dayCustomerSameSum.ruleItemList" :key="index">
                        <el-checkbox @change="item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)"  v-model="item.enabled"></el-checkbox>
                        <span class="txt"><i class="theme-color">{{item.customerType==1?'药店':item.customerType==2?'商业公司':item.customerType==4?'医院':'其他'}}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input @input="$forceUpdate();$emit('changeData',newBizParam)"  class="rule-input-box" v-model="item.sumLimitMax" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                            :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                        <p class="tips" v-if="!item.sumLimitMax&&item.enabled&&isOpenCheck">请将规则填写完整</p>
                    </div>
                </div>
                <!-- 规则6 end-->

                <!-- 规则7 start-->
                <div class="rule">
                  
                    <el-checkbox @change="changeCheck(5);$emit('changeData',newBizParam)" v-model="newBizParam.monthCustomerSameSum.enabled"></el-checkbox>
                    <span class="txt">规则3：限制</span>
                    <div :class="!newBizParam.monthCustomerSameSum.isSamePerson&&newBizParam.monthCustomerSameSum.enabled&&isOpenCheck?'red-border':''">
                        <el-select @change="isSamePersonChange" :disabled="!newBizParam.monthCustomerSameSum.enabled" class="w130" v-model="newBizParam.monthCustomerSameSum.isSamePerson" placeholder="请选择" clearable>
                            <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <span class="txt"><i class="theme-color">同一月</i>收集<i class="theme-color">同一家企业客户</i>的频次</span>
                    <p class="tips" v-if="!newBizParam.monthCustomerSameSum.isSamePerson&&newBizParam.monthCustomerSameSum.enabled&&isOpenCheck">请将规则填写完整</p>

                </div>
                <div class="rule-child" v-if="newBizParam.monthCustomerSameSum.enabled">
                    <div class="rule" v-for="(item,index) in newBizParam.monthCustomerSameSum.ruleItemList" :key="index">
                        <el-checkbox @change="item.isSamePersonExecute=null;item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)"  v-model="item.enabled"></el-checkbox>
                        <span class="txt"><i class="theme-color">{{ item.customerType==1?'药店':item.customerType==2?'商业公司':item.customerType==4?'医院':'其他' }}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input @input="$forceUpdate();$emit('changeData',newBizParam)"  class="rule-input-box" v-model="item.sumLimitMax" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                            :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                        <template v-if="newBizParam.monthCustomerSameSum.isSamePerson =='N'">
                            <el-checkbox v-model="item.isSamePersonExecute" :disabled="!item.enabled||newBizParam.monthCustomerSameSum.isSamePerson=='Y'"></el-checkbox>
                            <span class="txt">必须同一人执行</span>
                        </template>

                        <p class="tips" v-if="!item.sumLimitMax&&item.enabled&&isOpenCheck">请将规则填写完整</p>
                    </div>
                </div>
                <!-- 规则7 end-->
            </el-tab-pane>
            <el-tab-pane label="自定义" name="second" >
                <!-- 规则11 start -->
                <div class="rule">
                  
                    <el-checkbox @change="changeCheck(11);$emit('changeData',newBizParam)"  v-model="newBizParam.diyDayCustomerSumAndSame.enabled"></el-checkbox>
                    <span class="txt">规则4：限制</span>
                    <div :class="!newBizParam.diyDayCustomerSumAndSame.isSamePerson&&newBizParam.diyDayCustomerSumAndSame.enabled&&isOpenCheck?'red-border':''">
                        <el-select @change="$emit('changeData',newBizParam)" :disabled="!newBizParam.diyDayCustomerSumAndSame.enabled" class="w130" v-model="newBizParam.diyDayCustomerSumAndSame.isSamePerson" placeholder="请选择" clearable>
                            <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <span class="txt">同核算月内每</span>
                    <div :class="!newBizParam.diyDayCustomerSumAndSame.dayLimitMax&&newBizParam.diyDayCustomerSumAndSame.enabled&&isOpenCheck?'red-border':''">
                        <el-input class="rule-input-box" v-model="newBizParam.diyDayCustomerSumAndSame.dayLimitMax" @blur="dayLimitMaxBlur('diyDayCustomerSumAndSame')"    @input="$forceUpdate();$emit('changeData',newBizParam)"  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                            :min="1" :maxlength="7" :disabled="!newBizParam.diyDayCustomerSumAndSame.enabled"></el-input>
                    </div> 
                    <span class="txt">天内采集<i class="theme-color">企业客户</i>的频次
                        <el-tooltip effect="light" placement="top-start">
                            <i class="el-icon-question"></i>
                            <p slot="content">
                                举例：同一个业务员采集同一个药店每两周不得超过2次这个规则的含义是：
                                <br>
                                1、从某个核算月的第一天开始，顺着往后推每14天不能超过2次，最后一周如果不满14天，
                                <br>
                                &nbsp;&nbsp;那么按照从最后一周的第一天到当前核算月最后一天这个时间范围判断是否超出限制，如果超出也拦截。
                                <br>
                                2、案例1：2025年6月，某企业是自然月核算，那么6/1-6/14、6/15-6/28、6/29-6/30 同一个周期内不能超过2次。
                                <br>
                                3、案例2：2025年6月，某企业是5月25-6月26日核算，那么5/25-6/7、6/8-6/21、6/22-6/30 同一个周期内不能超过2次
                            </p>
                        </el-tooltip>
                    </span>
                    <p class="tips" v-if="(!newBizParam.diyDayCustomerSumAndSame.isSamePerson||!newBizParam.diyDayCustomerSumAndSame.dayLimitMax)&&newBizParam.diyDayCustomerSumAndSame.enabled&&isOpenCheck">请将规则填写完整</p>
                </div>
                <div class="rule-child" v-if="newBizParam.diyDayCustomerSumAndSame.enabled">
                    <div class="rule" v-for="(item,index) in newBizParam.diyDayCustomerSumAndSame.ruleItemList" :key="index">
                        <el-checkbox @change="item.sameLimitMax=null;item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)" v-model="item.enabled"></el-checkbox>
                        <span class="txt"><i class="theme-color">{{ item.customerType==1?'药店':item.customerType==2?'商业公司':item.customerType==4?'医院':'其他' }}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="item.sumLimitMax"  @input="$forceUpdate();$emit('changeData',newBizParam)" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                            :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次，同一家不可超过<span :class="!item.sameLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="item.sameLimitMax" @input="$forceUpdate();$emit('changeData',newBizParam)"  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                            :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                        <p class="tips" v-if="(!item.sameLimitMax||!item.sumLimitMax)&&item.enabled&&isOpenCheck">请将规则填写完整</p>
                    </div>
                </div>
                <!-- 规则11 end-->

                <!-- 规则12 start-->
                <div class="rule">
                  
                    <el-checkbox @change="changeCheck(12);$emit('changeData',newBizParam)" v-model="newBizParam.diyDayCustomerSameSum.enabled"></el-checkbox>
                    <span class="txt">规则5：限制</span>
                    <div :class="!newBizParam.diyDayCustomerSameSum.isSamePerson&&newBizParam.diyDayCustomerSameSum.enabled&&isOpenCheck?'red-border':''">
                        <el-select @change="$emit('changeData',newBizParam)" :disabled="!newBizParam.diyDayCustomerSameSum.enabled" class="w130" v-model="newBizParam.diyDayCustomerSameSum.isSamePerson" placeholder="请选择" clearable>
                            <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                   <span class="txt">同核算月内每</span>
                    <div :class="!newBizParam.diyDayCustomerSameSum.dayLimitMax&&newBizParam.diyDayCustomerSameSum.enabled&&isOpenCheck?'red-border':''">
                        <el-input class="rule-input-box" v-model="newBizParam.diyDayCustomerSameSum.dayLimitMax"  @blur="dayLimitMaxBlur('diyDayCustomerSameSum')"  @input="$forceUpdate();$emit('changeData',newBizParam)"  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                            :min="1" :maxlength="7" :disabled="!newBizParam.diyDayCustomerSameSum.enabled"></el-input>
                    </div> 
                    <span class="txt">天内采集<i class="theme-color">同一家企业客户</i>的频次
                        <el-tooltip effect="light" placement="top-start">
                            <i class="el-icon-question"></i>
                            <p slot="content">
                                举例：同一个业务员采集同一个药店每两周不得超过2次这个规则的含义是：
                                <br>
                                1、从某个核算月的第一天开始，顺着往后推每14天不能超过2次，最后一周如果不满14天，
                                <br>
                                &nbsp;&nbsp;那么按照从最后一周的第一天到当前核算月最后一天这个时间范围判断是否超出限制，如果超出也拦截。
                                <br>
                                2、案例1：2025年6月，某企业是自然月核算，那么6/1-6/14、6/15-6/28、6/29-6/30 同一个周期内不能超过2次。
                                <br>
                                3、案例2：2025年6月，某企业是5月25-6月26日核算，那么5/25-6/7、6/8-6/21、6/22-6/30 同一个周期内不能超过2次
                            </p>
                        </el-tooltip>
                    </span>
                    <p class="tips" v-if="(!newBizParam.diyDayCustomerSameSum.isSamePerson||!newBizParam.diyDayCustomerSameSum.dayLimitMax)&&newBizParam.diyDayCustomerSameSum.enabled&&isOpenCheck">请将规则填写完整</p>
                </div>
                <div class="rule-child" v-if="newBizParam.diyDayCustomerSameSum.enabled">
                    <div class="rule" v-for="(item,index) in newBizParam.diyDayCustomerSameSum.ruleItemList" :key="index">
                        <el-checkbox @change="item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)"  v-model="item.enabled"></el-checkbox>
                        <span class="txt"><i class="theme-color">{{item.customerType==1?'药店':item.customerType==2?'商业公司':item.customerType==4?'医院':'其他'}}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input @input="$forceUpdate();$emit('changeData',newBizParam)"  class="rule-input-box" v-model="item.sumLimitMax" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                            :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                        <p class="tips" v-if="!item.sumLimitMax&&item.enabled&&isOpenCheck">请将规则填写完整</p>
                    </div>
                </div>
                <!-- 规则6 end-->
            </el-tab-pane>
        </el-tabs>
    </section>
</template>
  
<script>
export default {
    props: ['bizParam1'],
    data() {
        return {
            ruleModel1:'first',
            ruleModel2:'first',
            isOpenCheck:false,
            optionSCDY1: [
                {
                    value: '3',
                    label: '医生',
                },
                {
                    value: '10',
                    label: '商业客户',
                },
                {
                    value: '11',
                    label: '居间人',
                },
                {
                    value: '15',
                    label: '药店联系人',
                },
            ],
            isSamePersonOption:[
                {
                    value: 'Y',
                    label: '同一人员',
                },
                {
                    value: 'N',
                    label: '不同人员',
                },
            ],
            newBizParam:null,

        };
    },
    watch: {
        bizParam1: {
            deep: true,
            handler(newBizParam) {
           
                if (!this.$route.query.guid&&this.$route.query.type!=3) return
                this.newBizParam = JSON.parse(JSON.stringify(newBizParam));
                console.log('-------')
                console.log(this.newBizParam)
                this.$forceUpdate();
            }
        }
    },
    created() {
       if (this.$route.query.guid||this.$route.query.type==3) return
       this.newBizParam = this.bizParam1;
     this.changeCheck(0);
       
    },
    methods: {
        dayLimitMaxBlur(param){
            if( this.newBizParam[param].dayLimitMax==1){
                this.newBizParam[param].dayLimitMax = null;
            }
        },
        isSamePersonChange(){
            this.newBizParam.monthCustomerSameSum.ruleItemList.forEach(item=>{
                item.isSamePersonExecute = null;
            })
             this.$emit('changeData',this.newBizParam)
             console.log(this.newBizParam)
            this.$forceUpdate();
        },
        changeCheck(i) {

            //规则5
            if (!this.newBizParam.dayCustomerSumAndSame.enabled && (i == 3||i==0)) {
                this.newBizParam.dayCustomerSumAndSame = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "1",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "2",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                    ]
                }
            }
            //规则11
            if (!this.newBizParam.diyDayCustomerSumAndSame.enabled && (i ==11||i==0)) {
                this.newBizParam.diyDayCustomerSumAndSame = {
                    "enabled": false,
                    "isSamePerson": null,
                    "dayLimitMax": null,
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "1",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "2",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },

                    ]
                }
            }

            //规则7
            if (!this.newBizParam.monthCustomerSameSum.enabled && (i == 5||i==0)) {
                this.newBizParam.monthCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "1",
                            "sumLimitMax": null,
                            "isSamePersonExecute":null
                        },
                        {
                            "enabled": false,
                            "customerType": "2",
                            "sumLimitMax": null,
                            "isSamePersonExecute":null
                        },
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sumLimitMax": null,
                            "isSamePersonExecute":null
                        },
                    ]
                }
            }
            //规则6
            if (!this.newBizParam.dayCustomerSameSum.enabled && (i == 6||i==0)) {
                this.newBizParam.dayCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                         {
                            "enabled": false,
                            "customerType": "1",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "2",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                    ]
                }
            }
            //规则12
            if (!this.newBizParam.diyDayCustomerSameSum.enabled &&(i == 12||i==0)) {
                this.newBizParam.diyDayCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": null,
                    "dayLimitMax": null,
                    "ruleItemList": [
                     {
                            "enabled": false,
                            "customerType": "1",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "2",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        },
                    ]
                }
            }
            this.$forceUpdate();
        },
        checkResult() {
            this.isOpenCheck = true;
            this.$forceUpdate();
            let { selectItemNum,diyDayCustomerSumAndSame, dayCustomerSumAndSame, monthItemSameSum, monthCustomerSameSum, dayCustomerSameSum,diyDayCustomerSameSum,diyDayItemSum } = this.newBizParam;
            //规则1 校验
            if (selectItemNum.enabled && (!selectItemNum.limitMax || !selectItemNum.ruleItemList || !selectItemNum.ruleItemList.length)) return;
            //规则10 校验
            if (diyDayItemSum.enabled && !diyDayItemSum.isSamePerson) return;
            try {
                let count = 0;
                diyDayItemSum.ruleItemList.forEach(k => {
                    if (diyDayItemSum.enabled&&!k.enabled) {
                        count++;
                    }
                    if (count == 3) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && !k.sumLimitMax) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            //规则4 校验
            if (monthItemSameSum.enabled && !monthItemSameSum.isSamePerson) return;
            try {
                let count = 0;
                monthItemSameSum.ruleItemList.forEach(k => {
                    if (monthItemSameSum.enabled&&!k.enabled) {
                        count++;
                    }
                    if (count == 3) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && !k.sumLimitMax) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            //规则5 校验
            if (dayCustomerSumAndSame.enabled && !dayCustomerSumAndSame.isSamePerson) return;
            try {
                let count = 0;
                dayCustomerSumAndSame.ruleItemList.forEach(k => {
                    if (dayCustomerSumAndSame.enabled&&!k.enabled) {
                        count++;
                    }
                    if (count == 3) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && (!k.sumLimitMax || !k.sameLimitMax)) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            //规则11
            if (diyDayCustomerSumAndSame.enabled && (!diyDayCustomerSumAndSame.isSamePerson||!diyDayCustomerSumAndSame.dayLimitMax)) return;
            try {
                let count = 0;
                diyDayCustomerSumAndSame.ruleItemList.forEach(k => {
                    if (diyDayCustomerSumAndSame.enabled&&!k.enabled) {
                        count++;
                    }
                    if (count == 3) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && (!k.sumLimitMax || !k.sameLimitMax)) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
       
            //规则6 校验
            if (monthCustomerSameSum.enabled && !monthCustomerSameSum.isSamePerson) return;
            try {
                let count = 0;
                monthCustomerSameSum.ruleItemList.forEach(k => {
                    if (monthCustomerSameSum.enabled&&!k.enabled) {
                        count++;
                    }
                    if (count == 3) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && !k.sumLimitMax) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
         
            if (dayCustomerSameSum.enabled && !dayCustomerSameSum.isSamePerson) return;
            try {
                let count = 0;
                dayCustomerSameSum.ruleItemList.forEach(k => {
                    if (dayCustomerSameSum.enabled&&!k.enabled) {
                        count++;
                    }
                    if (count == 3) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && !k.sumLimitMax) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            
           //规则12 校验
            if (diyDayCustomerSameSum.enabled && (!diyDayCustomerSameSum.isSamePerson||!diyDayCustomerSameSum.dayLimitMax)) return;
            try {
                let count = 0;
                diyDayCustomerSameSum.ruleItemList.forEach(k => {
                    if (diyDayCustomerSameSum.enabled&&!k.enabled) {
                        count++;
                    }
                    if (count == 3) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && !k.sumLimitMax) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            return true;
            
        }
    }
};
</script>
  
<style scoped>
.rule {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
}
.w260{
    width: 260px; 
}

.w130 {
    width: 140px;
}

.rule-input-box {
    width: 90px;
}
.txt{
    margin:0 10px;
}
.theme-color{
    color:#4FA1A4;
    font-style: normal;
}
.tips-color{
    color:red;
    font-style: normal;
}
.rule-child{
    padding-left: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    background: #fafafa;
    margin-bottom: 10px;
    margin-left: 72px;
}
.tips{
    color:red;
    font-size: 12px;
}
.red-border{
    border: 1px solid red;
    border-radius: 4px;
}
.red-border /deep/ .el-input__inner{
    border: 0 none;
}
span{
    display: inline-block;
}
.rule-child .rule:last-child{
    margin-bottom: 0px;
}
.line{
    height: 1px;
    background: #d9d9d9;
    margin:16px 0;
}
h5{
    font-size: 14px;
    color: #212212;
    width: 140px;
    text-align: left;
    margin:0;
    font-weight: normal;
}
/deep/ .el-tabs__active-bar{
    width:72px !important;
}
</style>
  